import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import copyIcon from "../../assets/images/copyIcon.svg";
import { Col, Form, Row } from "react-bootstrap";
import infoIcon from "../../assets/images/infobtnblue.svg";
import { API_URL } from "../../services/APIRoute";
import { toast } from "react-toastify";

function SaveAsCopyModal(props) {
    // props?.flowName
    const [newFlowName, setNewFlowName] = useState("");
    const [copyFlowErrMsg, setCopyFlowErrMsg] = useState("");

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="delete-modal"
        >
            <Modal.Body>
                <div className="text-center">
                    <img src={copyIcon} alt="copyIcon" className="modal-delete-icon" />
                    <h4>Want to Copy Work-Flow ?</h4>
                    <Row className="mb-3 mt-3">
                        <Col xl={12} className="text-start">
                            <Form.Group className="form-group mb16">
                                <Form.Label className="common-label">Work-flow Name</Form.Label>

                                <div className="position-relative">
                                    <div className={`${copyFlowErrMsg && "error-border-line"}`}>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter new work-flow name"
                                            className="common-input"
                                            value={newFlowName}
                                            // onChange={(e) => setNewFlowName(e.target.value)}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                // const regEx = /^[a-z0-9 ]*$/i;
                                                const regEx = /^[a-z0-9\- ]*$/i;
                                                const isValid = regEx.test(val);
                                                if (val === "") {
                                                    setNewFlowName("");
                                                } else if (isValid) {
                                                    setNewFlowName(val);
                                                }
                                            }}
                                        />
                                    </div>
                                    {copyFlowErrMsg && (
                                        <p className="error-line">
                                            <span className="error-message-icon">
                                                <img
                                                    src={infoIcon}
                                                    alt="infoIcon"
                                                    title={copyFlowErrMsg}
                                                />
                                            </span>
                                        </p>
                                    )}
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>

                    {/* <p>Please confirm if you wish to proceed with deleting this item.</p> */}
                    <div className="d-flex align-items-center gap-2">
                        <button className="grey-btn" onClick={props.onHide}>
                            Cancel
                        </button>
                        <button
                            className="red-btn"
                            onClick={() => {
                                if (newFlowName === "") {
                                    setCopyFlowErrMsg("Work-flow name is required.");
                                    return;
                                }
                                // Condition Apply only in beta environment. As discussed with satish/Ashish
                                if (API_URL.BASEURL.includes("beta")) {
                                    const workFlowName = newFlowName; // ?.trim();
                                    if (
                                        !workFlowName ||
                                        workFlowName.substring(0, 5).toLowerCase() !== "beta-" // must start with beta
                                    ) {
                                        toast.error("Workflow Name must start with 'beta-'.");
                                        return;
                                    }
                                }


                                if (newFlowName.toLowerCase().indexOf("sandbox") >= 0) {
                                    toast.error("The keyword 'SANDBOX' is not allowed in workflow names.");
                                    return;
                                }

                                setCopyFlowErrMsg("");
                                props.handleWorkFlowCopy(newFlowName);
                                props.onHide();
                            }}
                        >
                            Yes, Copy
                        </button>
                    </div>
                </div>
            </Modal.Body>
            {/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
        </Modal>
    );
}

export default SaveAsCopyModal;
